/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import React from 'react';
import {withRouter} from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import {parse as qsParse} from 'query-string'
import {Routes} from "../utils/Routes";
import {bindActionCreators} from "redux";
import {userHasActivity} from "../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../security/SecurityConst";
import * as SecurityActions from "../security/SecurityActions";
import Loader from "../common/Loader";

class AirtimeMainPage extends React.Component {
    constructor(props) {
        super(props);
        this.state= {
            loading: true,
        }
    }

    componentDidMount(){
        this.props.SecurityActions.signOut();
        this.parseCode()
    }

    changeLanguageLocal(lang) {
        localStorage.setItem('lang', lang);
    }

    parseCode() {
        const parsed = qsParse(this.props.location.search)
        localStorage.setItem("sessionId", parsed.id)
        this.props.SecurityActions.authenticateUniqueSession(parsed.id).then((profile) => {
            if (profile) {
                if (userHasActivity(profile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES)) {
                    this.changeLanguageLocal(profile.languageCode + '_hda')
                } else {
                    this.changeLanguageLocal(profile.languageCode)
                }
                this.props.history.push({
                    pathname: '/airtime/process?id=' + parsed.id,
                    state: {sessionId: parsed.id},
                })
                window.location.reload()
            }
        }).catch(() => {
            this.props.history.push(Routes.LOGIN)
        })
    }

    render() {
        return <Loader text="Signing in" loading={true}/>
    }
}

const mapStateToProps= state => {
    return {
        security: state.security,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        SecurityActions: bindActionCreators(SecurityActions, dispatch),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AirtimeMainPage))